"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PackageSelection = PackageSelection;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _useTranslations = require("../hooks/useTranslations");
var _logger = require("../logger");
var _ModalContent = require("./ModalContent");
var _PackagePicture = require("./PackagePicture");
var _PackagesLoader = require("./PackagesLoader");
var _jsxRuntime = require("react/jsx-runtime");
const Filters = (0, _mui.styled)('section')({
  width: '100%'
});
const Packages = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  overflow: 'auto',
  rowGap: theme.spacing(3),
  paddingBottom: theme.spacing(1),
  color: theme.palette.grey[200] // needed because it is inherited by button
}));
const PackageButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  borderRadius: theme.shape.borderRadius,
  justifyContent: 'stretch',
  padding: theme.spacing(2, 3)
}));
const PackageLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textAlign: 'left',
  textTransform: 'none',
  color: theme.palette.text.primary
}));
function PackageSelection() {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    setPackage,
    selectedPackage
  } = (0, _react.useContext)(_contexts.stateContext);
  const [filter, setFilter] = (0, _react.useState)(0);
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    packages,
    categories,
    isLoading
  } = (0, _hooks.usePackageSelectionLogic)(filter);
  (0, _logger.logDebug)('PackageSelection selectedPackage: ', selectedPackage);
  (0, _react.useEffect)(() => {
    if (categories.length === 1) {
      const categoryTypeId = categories[0]?.typeId ?? 0;
      setFilter(categoryTypeId);
    }
  }, [categories]);
  const onClickSetPackage = autoshipPackage => () => setPackage(autoshipPackage);
  const onClickSetFilter = categoryFilter => () => setFilter(categoryFilter);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalContent.ModalContent, {
    dataId: "package-selection",
    children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PackagesLoader.PackagesLoader, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Filters, {
        children: [categories.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
          clickable: true,
          label: formatMessage('all'),
          size: "small",
          sx: {
            marginRight: 2
          },
          variant: filter > 0 ? 'outlined' : undefined,
          onClick: onClickSetFilter(0)
        }), categories.map(category => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
          clickable: true,
          label: category.description,
          size: "small",
          variant: filter === category.typeId ? undefined : 'outlined',
          sx: {
            marginRight: 2
          },
          ...getTestIdProps(`${category.category}`),
          onClick: onClickSetFilter(category.typeId)
        }, category.typeId))]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Packages, {
        ...getTestIdProps('packages'),
        children: packages.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(PackageButton, {
          disableRipple: true,
          fullWidth: true,
          color: "inherit",
          size: "small",
          startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PackagePicture.PackagePicture, {
            url: item.imageSrc,
            alt: item.description
          }),
          sx: item.packageId === selectedPackage?.packageId ? {
            borderColor: 'text.primary'
          } : undefined,
          ...getTestIdProps(`package-${item.packageId}-button`),
          type: "button",
          variant: "outlined",
          onClick: onClickSetPackage(item),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PackageLabel, {
            variant: "body1",
            ...getTestIdProps('package-label'),
            children: item.description
          })
        }, item.packageId))
      })]
    })
  });
}
